import { Popover } from "antd";
import { PlacementPositions } from "../../enums/PlacementPositionsEnums";
import styles from "./ExternalRolesConfig.module.scss";
import { MdDelete, MdModeEdit } from "react-icons/md";
import MoreEllipsis from "../../assets/images/documentEllipse.svg";
import { PopoverTrigger } from "../../enums//PopoverEnums";
import * as Yup from "yup";

export const getExternalRolesColumns = ({
  handleEditAction,
  handleDeleteAction,
}) => [
  {
    title: "ROLE",
    key: "roleName",
    dataIndex: "roleName",
    width: "180px",
  },
  {
    title: "CREATED BY",
    key: "createdBy",
    dataIndex: "createdBy",
    width: "180px",
  },
  {
    title: "CREATED DATE",
    key: "createdDate",
    dataIndex: "createdDate",
    width: "300px",
    render: (val, record) => (
      <>
        {val}, {record?.createdTime}
      </>
    ),
  },
  {
    title: "",
    key: "actions",
    dataIndex: "actions",
    fixed: "right",
    width: "50px",
    align: "center",
    render: (_, record) => (
      <Popover
        placement={PlacementPositions.LEFT}
        trigger={PopoverTrigger.HOVER}
        content={
          <>
            <div
              className={styles.PopoverContent}
              onClick={() => handleEditAction(record)}
            >
              <MdModeEdit />
              Edit
            </div>
            <div
              className={styles.PopoverContent}
              onClick={() => handleDeleteAction(record)}
            >
              <MdDelete />
              Delete
            </div>
          </>
        }
      >
        <span className={styles.editEllipsis}>
          <img src={MoreEllipsis} alt={"More options"} />
        </span>
      </Popover>
    ),
  },
];

export const ADD_ROLE_BUTTON_TEXT = "+ Add Role";
export const DELETE_ROLE_MSG = "Role Deleted Succesfully";

export const addRoleValidation = Yup.object().shape({
  roleName: Yup.string().required("Role name is required"),
});
